import type { ControlByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetControlByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetControlByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetControlByIdArgs = {
  controlId: string;
};

export const useLazyGetControlById = createLazyQueryHook<
  UseLazyGetControlByIdArgs,
  ControlByIdResponseRow[],
  GetControlByIdQuery
>({
  trpcQuery: (client, { controlId }) =>
    client.frontend.control.controlById.query({ controlId }),
  mapTrpcDataToGraphQL: (data) => ({ control: data }),
  graphqlDocument: GetControlByIdDocument,
  graphqlVariables: ({ controlId }) => ({ _eq: controlId }),
});
